<script lang="ts">
  import { AnchorInline } from '$lib/components/anchor';
  import { TextCopy } from '$lib/components/text';
  import { AppPath } from '$lib/features/app';
  import type { PersonBaseDto } from '$lib/features/bff/sdk';
  import { formatTaxId } from '$lib/features/format';

  /** Required */
  export let person: PersonBaseDto;
</script>

<AnchorInline
  label={person.name}
  href={person.type === 'LEGAL' ? `${AppPath.OFFICE}/${person.taxId}` : `${AppPath.PERSON}/${person.id}`}
/>

{#if person.type === 'NATURAL'}
  <br />
  <TextCopy font="text-xs" value={formatTaxId(person.taxId)} onCopy={(v) => v.replace(/[.-]+/g, '')} />

  {#if person.age}
    <span class="text-surface-500-400-token">•</span>
    <TextCopy font="text-xs" value={`${person.age} anos`} />
  {/if}
{:else if person.type === 'LEGAL'}
  <br />
  <TextCopy font="text-xs" value={formatTaxId(person.taxId)} onCopy={(v) => v.replace(/\D+/g, '')} />
{:else if person.type === 'FOREIGN'}
  <br />
  <TextCopy font="text-xs" value={person.country.name} />
{/if}
